import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Container, Row, Col } from 'reactstrap'
import { HorizontalBar, Pie, Chart } from 'react-chartjs-2'
import { withStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import Alert from 'react-s-alert'

import AudienceRecoComponent from './AudienceRecoComponent'
import SegmentationComponent from './SegmentationComponent'
import Spinner from '../Spinner'
import Profile from '../../classes/profile'
import * as f from '../../classes/Filters'
import { DefaultFilters } from '../../reducers/topics_reducer'
import { PlanFilters } from '../../classes/FilterHelpers'
import { CURRENT_FILTER, DEMOGRAPHICS, DEMOGRAPHICS_MODULE, FILTER_MODE_MENU } from '../../constants/commons'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { styles } from '../../classes/Styles'
import { GENDER_DEOMGRAPHICS, AGE_DEOMGRAPHICS } from '../../constants/module_info'

export class AudienceDemoComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    location: PropTypes.object.isRequired,
    loadMore: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    otherFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    shortcutPreference: PropTypes.string,
    topicDetails: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    topicPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object,
      endOfResult: PropTypes.bool.isRequired
    }).isRequired,
    topicPlanDemographics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    topicPlanSegments: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.array
    }),
    screenWidth: PropTypes.number,
    fetchTopicPlan: PropTypes.func
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(DEMOGRAPHICS_MODULE, this.props.location, this.props.profile)
    this.props.setFilters(PlanFilters.Lifestyle, CURRENT_FILTER, DEMOGRAPHICS, FILTER_MODE_MENU)
    setTimeout(() => {
      this.props.fetchTopicPlan(DEMOGRAPHICS, FILTER_MODE_MENU)
    }, 500)
    Chart.pluginService.register({
      afterDraw: function (chart) {
        let ctx = chart.ctx
        ctx.textAlign = 'left'
        ctx.textBaseline = 'center'
        ctx.fillStyle = '#808184'
        ctx.font = '14px Uni Sans Light'
        chart.config.data.datasets.forEach(function (dataset) {
          if (dataset.label === 'Age Demographics'){
            const dataArray = dataset.data
            const key = Object.keys(dataset._meta)
            dataset._meta[key].data.forEach(function (bar, index) {
              ctx.fillText(dataArray[index] === 0 ? '<1%' : `${dataArray[index]}%`, bar._view.x + 5, bar._view.y + 5)
            })
          }
      })
      }
    })
  }

  componentDidUpdate (prevProps) {
    if (this.props.topicDetails.error && !prevProps.topicDetails.error) {
      Alert.error('Error fetching audience, please retry')
    }
    if (this.props.topicPlan.error && !prevProps.topicPlan.error) {
      Alert.error('Error fetching plan, please retry')
    }
    if (!this.props.filters.equals(prevProps.filters)) {
      console.log('new filters', this.props.filters.toString())
    }
    if (this.props.topicPlan !== prevProps.topicPlan) {
      console.log('new plan', this.props.topicPlan)
    }
  }

  render () {
    if (this.props.topicDetails.isFetching) {
      return (<Spinner />)
    }

    const tlmCol = this.props.screenWidth < 1024 ? 12 : this.props.screenWidth >= 1300 ? 7 : 6
    const recoCol = this.props.screenWidth < 1024 ? 12 : this.props.screenWidth >= 1300 ? 5 : 6
    const demoCol = this.props.screenWidth < 1300 ? 12 : 6
    return (
      <Row>
        <Container fluid={true} className="rightSideContainer audienceContainer">
          <Row>
            <Col xl={tlmCol} lg={tlmCol} md={12} sm={12} className="leftRow">
              <div className={`borderBox getScreenHeight ${this.props.topicPlanDemographics.error ? 'p-0' :''}`}>
                { this.props.topicPlanDemographics.error ?
                  <Box className='getScreenHeight noDemograpgics'>
                    <span>Demographic charts will be available here soon</span>
                  </Box> :
                  <Row>
                    <Col xl={demoCol} lg={demoCol} md={12} sm={12} className="genderChart">
                      <GenderDemographics demo={this.props.topicPlanDemographics} classes={this.props.classes}/>
                    </Col>
                    <Col xl={demoCol} lg={demoCol} md={12} sm={12}>
                      <AgeDemographics demo={this.props.topicPlanDemographics} classes={this.props.classes}/>
                    </Col>
                  </Row>
                }
              </div>
            </Col>
            <Col xl={recoCol} lg={recoCol} md={12} sm={12}>
              <AudienceRecoComponent
                topicPlan={this.props.topicPlan}
                loadMore={this.props.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                programmingFilters={this.props.programmingFilters}
                otherFilters={this.props.otherFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                location={this.props.location}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                fetchTopicPlan={this.props.fetchTopicPlan}
                />
            </Col>
          </Row>
        </Container>
      </Row>
    )
  }
}

export const GenderDemographics = ({demo, classes}) => {
  if (!demo.details) {
    return null
  }

  const male = demo.details.num_male
  const female = demo.details.num_female
  const data = {
    labels: [
      `Male (${male}%)`,
      `Female (${female}%)`
    ],
    datasets: [{
      data: [male, female],
      backgroundColor: [
        '#4089fb',
        '#00b5ee'
      ],
      borderWidth: 0
    }]
  }
  const options = {
    maintainAspectRatio: true,
    responsive: true,
    weight: 1,
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 10,
        pointStyle: 'circle',
        usePointStyle: true
      },
      display: false
    },
    tooltips: {
      enabled: false
    },
    cutoutPercentage: 78
  }

  return (
    <>
      <Row className='demoRow'>
        <div className="demoHeader demoGenderHeader leftMargin">
          Gender Demographics
          <OverlayTrigger overlay={<Tooltip id="tooltip">{GENDER_DEOMGRAPHICS}</Tooltip>} placement="right">
            <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
          </OverlayTrigger>
        </div>
        <div className='doughnutChart'>
          <Pie data={data} options={options} />
        </div>
      </Row>
      <Row className='genderLegent'>
        <span className='femaleCircle'></span>Female ({female}%)
        <span className='maleCircle'></span>Male ({male}%)
      </Row>
    </>
  )
}

GenderDemographics.propTypes = {
  classes: PropTypes.object.isRequired,
  demo: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object,
    details: PropTypes.object
  })
}

export const AgeDemographics = ({demo, classes}) => {
  if (!demo.details) {
    return null
  }

  const ageUnder18 = demo.details.num_age_under18
  const age18To24 = demo.details.num_age18_to24
  const age25To34 = demo.details.num_age25_to34
  const age35To54 = demo.details.num_age35_to54
  const age55Plus = demo.details.num_age55_plus

  const data = {
    labels: ['<18', '18-24', '25-34', '35-54', '55+'],
    datasets: [
      {
        label: 'Age Demographics',
        backgroundColor: 'rgba(161, 109, 196, 1)',
        borderColor: 'rgba(161, 109, 196, 1)',
        // borderWidth: 1,
        // hoverBackgroundColor: 'rgba(161, 109, 196, 0.4)',
        // hoverBorderColor: 'rgba(161, 109, 196, 1)',
        data: [ageUnder18, age18To24, age25To34, age35To54, age55Plus],
        barPercentage: 1
      }
    ]
  }
  const options = {
    maintainAspectRatio: true,
    responsive: true,
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    scales: {
      yAxes: [{
        ticks: {
          fontSize: 14,
          fontColor: '#808184',
          fontFamily: 'Uni Sans Regular'
        },
        gridLines: {
          display: false,
          drawBorder: false
        }
      }],
      xAxes: [{
        position: 'right',
        gridLines: {
          drawBorder: true,
          color: '#E6E7E8'
        },
        ticks: {
          fontSize: 14,
          fontColor: '#E6E7E8',
          max: 100,
          min: 0,
          stepSize: 20,
          callback: function (label) {
            // return (label === 0 || label ===20 || label === 40 || label === 60) ? `${label}%` : ''
            return `${label}%`
          }
        }
      }]
    }
  }

  return (
    <Row className='demoRow'>
      <div className="demoHeader demoAgeHeader leftMargin">
        Age Demographics
        <OverlayTrigger overlay={<Tooltip id="tooltip">{AGE_DEOMGRAPHICS}</Tooltip>} placement="right">
          <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
        </OverlayTrigger>
      </div>
      <div className='barChart'>
        <HorizontalBar data={data} options={options} />
      </div>
    </Row>
  )
}

AgeDemographics.propTypes = {
  classes: PropTypes.object.isRequired,
  demo: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object,
    details: PropTypes.object
  })
}

export const Segmentation = ({topicPlanSegments, filters, setFilters}) => {
  if (!topicPlanSegments || !topicPlanSegments.details) {
    return null
  }

  let selected = []
  const segmentFilter = segment => {
    return new f.Filters([
      new f.Filter({
        topic_sub_type: 'Channel',
        segments_or: segment
      })
    ])
  }

  topicPlanSegments.details.map( (item, index) => {
    if (index < 8) {
      let filter = segmentFilter(item.segment)
      if (filters.equals(filter)) {
        selected.push(item.segment)
      }
    }
    return selected
  })

  const onClick = (segment) => {
    // Any segmentation filter wipes out the existing set of filters. Also, no support for
    // clicking multiple segmentation filters (seeing 1 and 3 for instance)
    let newFilters = segmentFilter(segment)
    if (filters.equals(newFilters)) {
      newFilters = DefaultFilters
    }
    setFilters(newFilters, CURRENT_FILTER)
  }

  return (
    <SegmentationComponent
      topicPlanSegments={topicPlanSegments.details}
      onClick={onClick}
      selected={selected}
    />
  )
}

Segmentation.propTypes = {
  topicPlanSegments: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object,
    details: PropTypes.array
  }),
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired
}

export default withStyles(styles)(AudienceDemoComponent)